export default {
    data: [
        { id: 1, name: "交易" },
        { id: 2, name: "进人口" },
        { id: 3, name: "祭祀" },
        { id: 4, name: "沐浴" },
        { id: 5, name: "捕捉" },
        { id: 6, name: "入殓" },
        { id: 7, name: "除服" },
        { id: 8, name: "成服" },
        { id: 9, name: "安葬" },
        { id: 10, name: "谢土" },
        { id: 11, name: "启钻" },
        { id: 12, name: "修坟" },
        { id: 13, name: "嫁娶" },
        { id: 14, name: "纳采" },
        { id: 15, name: "订盟" },
        { id: 16, name: "造车器" },
        { id: 17, name: "祈福" },
        { id: 18, name: "造庙" },
        { id: 19, name: "安香" },
        { id: 20, name: "出火" },
        { id: 21, name: "出行" },
        { id: 22, name: "归宁" },
        { id: 23, name: "入学" },
        { id: 24, name: "入宅" },
        { id: 25, name: "立券" },
        { id: 26, name: "求医" },
        { id: 27, name: "治病" },
        { id: 28, name: "修造" },
        { id: 29, name: "动土" },
        { id: 30, name: "竖柱" },
        { id: 31, name: "上梁" },
        { id: 32, name: "盖屋" },
        { id: 33, name: "起基" },
        { id: 34, name: "安门" },
        { id: 35, name: "开市" },
        { id: 36, name: "会亲友" },
        { id: 37, name: "安机械" },
        { id: 38, name: "平治道涂" },
        { id: 39, name: "伐木" },
        { id: 40, name: "拆卸" },
        { id: 41, name: "安床" },
        { id: 42, name: "解除" },
        { id: 43, name: "立碑" },
        { id: 44, name: "移柩" },
        { id: 45, name: "馀事勿取" },
        { id: 46, name: "开光" },
        { id: 47, name: "定磉" },
        { id: 48, name: "移徙" },
        { id: 49, name: "造桥" },
        { id: 50, name: "造船" },
        { id: 51, name: "破土" },
        { id: 52, name: "塑绘" },
        { id: 53, name: "斋醮" },
        { id: 54, name: "纳畜" },
        { id: 55, name: "赴任" },
        { id: 56, name: "裁衣" },
        { id: 57, name: "栽种" },
        { id: 58, name: "破屋" },
        { id: 59, name: "坏垣" },
        { id: 60, name: "纳婿" },
        { id: 61, name: "作灶" },
        { id: 62, name: "畋猎" },
        { id: 63, name: "纳财" },
        { id: 64, name: "安碓磑" },
        { id: 65, name: "合帐" },
        { id: 66, name: "经络" },
        { id: 67, name: "扫舍" },
        { id: 68, name: "教牛马" },
        { id: 69, name: "挂匾" },
        { id: 70, name: "作梁" },
        { id: 71, name: "开池" },
        { id: 72, name: "补垣" },
        { id: 73, name: "取渔" },
        { id: 74, name: "修饰垣墙" },
        { id: 75, name: "求嗣" },
        { id: 76, name: "造仓" },
        { id: 77, name: "牧养" },
        { id: 78, name: "开厕" },
        { id: 79, name: "造畜稠" },
        { id: 80, name: "针灸" },
        { id: 81, name: "放水" },
        { id: 82, name: "理发" },
        { id: 83, name: "掘井" },
        { id: 84, name: "酬神" },
        { id: 85, name: "冠笄" },
        { id: 86, name: "结网" },
        { id: 87, name: "雇庸" },
        { id: 88, name: "开生坟" },
        { id: 89, name: "合寿木" },
        { id: 90, name: "塞穴" },
        { id: 91, name: "开仓" },
        { id: 92, name: "开柱眼" },
        { id: 93, name: "习艺" },
        { id: 94, name: "筑堤" },
        { id: 95, name: "架马" },
        { id: 96, name: "诸事不宜" },
        { id: 97, name: "整手足甲" },
        { id: 98, name: "置产" },
        { id: 99, name: "修门" },
        { id: 100, name: "断蚁" },
        { id: 101, name: "割蜜" },
        { id: 102, name: "出货财" },
        { id: 103, name: "雕刻" },
        { id: 104, name: "开渠" },
        { id: 105, name: "普渡" },
        { id: 106, name: "合脊" },
        { id: 107, name: "行丧" },
        { id: 108, name: "探病" },
        { id: 109, name: "词讼" },
        { id: 110, name: "分居" },
        { id: 111, name: "问名" },
        { id: 112, name: "乘船" }
    ]
}


// WEBPACK FOOTER //
// ./src/utils/yiji.js